import React, { useEffect, useState, useImperativeHandle, useRef } from 'react';
import style from './chooseGroup.module.scss';
import classnames from 'classnames/bind';
import { Checkbox, Input } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { api, apis } from 'api';
import lodashGet from 'lodash/get';
import { getIn18Text } from 'api';
const realStyle = classnames.bind(style);
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const ErrorDesc = {
    0: '',
    1: getIn18Text('ZUIDUOKESHURU'),
    2: getIn18Text('FENZUMINGCHENGYI'),
    3: '',
};
const systemApi = api.getSystemApi();
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
export const CreatePersonalGroup = React.forwardRef((props, ref) => {
    var _a;
    const { groupNames, cancel, success, customInputClass, _account = ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '' } = props;
    const [errorCode, setErrorCode] = useState(0);
    const [isChecked, setIsChecked] = useState(true);
    const [groupName, setGroupName] = useState('');
    const blurCreatelockRef = useRef(false);
    useImperativeHandle(ref, () => {
        return {
            addBlurCreateLock() {
                blurCreatelockRef.current = true;
            },
            createNewGroup: createNewGroup,
        };
    });
    const changeGroupName = e => {
        setGroupName(e.target.value);
    };
    const [disable, setDisable] = useState(false);
    const createNewGroupByBlur = async () => {
        if (blurCreatelockRef.current === true) {
            blurCreatelockRef.current = false;
            return;
        }
        return createNewGroup();
    };
    const createNewGroup = async () => {
        if (!groupName || !groupName.length) {
            cancel();
            return true;
        }
        const zhReg = /[\u4e00-\u9fa5]/g;
        const rules = [
            {
                rule(str) {
                    const zhLen = lodashGet(str.match(zhReg), 'length', 0);
                    const totalLength = zhLen + str.length;
                    return totalLength <= 40;
                },
                code: 1,
            },
            {
                rule(str) {
                    return !groupNames.includes(str);
                },
                code: 2,
            },
        ];
        const errorCode = rules.reduce((total, current) => {
            if (total !== 0) {
                return total;
            }
            const { rule, code } = current;
            const flag = rule(groupName);
            return flag ? 0 : code;
        }, 0);
        setErrorCode(errorCode);
        if (errorCode !== 0) {
            return false;
        }
        setDisable(true);
        try {
            const res = await contactApi.doInsertPersonalOrg({
                groupName: groupName.trim(),
                _account,
            });
            setDisable(false);
            if (!res.success) {
                setErrorCode(3);
                message.error(res.message);
                return false;
            }
            success(res.data, isChecked);
            return true;
        }
        catch (ex) {
            setErrorCode(3);
            return false;
        }
    };
    const inputRef = React.useRef(null);
    useEffect(() => {
        inputRef.current.focus({
            cursor: 'start',
        });
    }, []);
    useEffect(() => {
        errorCode !== 0 &&
            inputRef.current.focus({
                cursor: 'all',
            });
    }, [errorCode]);
    return (React.createElement("div", { className: realStyle('orgItem', 'newCreateOrgItem'), onMouseDown: e => {
            lodashGet(e, 'target.className', '').toLowerCase().includes('checkbox') && (blurCreatelockRef.current = true);
        } },
        React.createElement(Checkbox, { checked: isChecked, onChange: e => {
                blurCreatelockRef.current = true;
                setIsChecked(e.target.checked);
            } },
            React.createElement("p", { className: realStyle('newGroupLabel') },
                React.createElement(Input, { onBlur: () => {
                        return createNewGroupByBlur();
                    }, disabled: disable, value: groupName, onPressEnter: () => {
                        createNewGroup();
                    }, onChange: changeGroupName, "data-test-id": "contact_personalOrg_input", className: realStyle('newGroupInput', { error: errorCode !== 0 }, customInputClass), maxLength: 40, ref: inputRef }),
                React.createElement("span", { className: realStyle('errorTips', { visible: [1, 2].includes(errorCode) }) }, lodashGet(ErrorDesc, errorCode, ''))))));
});
